import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { ease } from "../../lib/content";

export const LandscapeBand = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-10%", "10%"]);
  const scale = useTransform(scrollYProgress, [0, 0.5, 1], [1.15, 1.05, 1.12]);
  return (
    <motion.section
      ref={ref}
      data-testid="home-landscape"
      className="relative bg-mist px-3 pb-3 sm:px-5 sm:pb-5"
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, amount: 0.1 }}
    >
      <motion.div
        className="relative h-[55vh] overflow-hidden sm:h-[80vh]"
        variants={{ hidden: { clipPath: "inset(8% 8% 8% 8%)" }, show: { clipPath: "inset(0% 0% 0% 0%)", transition: { duration: 1.4, ease } } }}
      >
        <motion.img
          src="/images/bss-landscape.jpg"
          alt="Aerial view of a patchwork of crop fields and tree lines"
          style={{ y, scale }}
          className="absolute inset-0 h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-teal-ink/70 via-transparent to-transparent" />
        <div className="absolute inset-x-0 bottom-0 flex flex-col gap-2 p-6 text-mist sm:flex-row sm:items-end sm:justify-between sm:p-10">
          <p className="max-w-xl font-display text-3xl font-light leading-tight sm:text-5xl">Working landscapes, designed for resilience.</p>
          <p className="label-caps !text-[11px] text-mist/85">New Zealand · Australia · Pacific</p>
        </div>
      </motion.div>
    </motion.section>
  );
};
